import {CdCarePlan} from '../../../interfaces/care/cd-care-plan/cd-care-plan';
import {LightCustomer} from '../../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../../customers/light-customer-factory';
import {LightEmployee} from '../../../interfaces/employees/light-employee';
import {LightEmployeeFactory} from '../../employees/light-employee-factory';
import {LightUser} from '../../../interfaces/core/light-user';
import {CdRai} from '../../../interfaces/care/cd-rai/cd-rai';
import {CdRaiFactory} from '../cd-rai/cd-rai-factory';
import {CdFrequency} from '../../../interfaces/care/cd-care-plan/cd-frequency';
import {CdFrequencyFactory} from './cd-frequency-factory';
import {CdPrescriptionFactory} from './cd-prescription-factory';
import {CdPrescription} from '../../../interfaces/care/cd-care-plan/cd-prescription';
import {CdCarePlanStatus} from '../../../enums/care/cd-care-plan/cd-care-plan-status';
import {LightUserFactory} from '../../core/light-user-factory';
import {CdAddedAim} from '../../../interfaces/care/cd-care-plan/cd-added-aim';
import {CdAddedAimFactory} from './cd-added-aim-factory';
import {CdAddedMeasure} from '../../../interfaces/care/cd-care-plan/cd-added-measure';
import {CdAddedMeasureFactory} from './cd-added-measure-factory';
import {CdPsaItem} from '../../../interfaces/care/cd-care-plan/cd-psa-item';
import {CdPsaItemFactory} from './cd-psa-item-factory';

export class CdCarePlanFactory {

  /**
   *
   * @param cdCarePlan
   */
  public static fromObject(cdCarePlan: any): CdCarePlan {
    const _cdCarePlan = new class implements CdCarePlan {
      cdClarificationId: number = cdCarePlan.c_clarification_id;
      canceled: string = cdCarePlan.canceled;
      created: string = cdCarePlan.created;
      customer: LightCustomer = cdCarePlan.customer ? LightCustomerFactory.fromObject(cdCarePlan.customer) : null;
      customerDocumentId: number = cdCarePlan.customer_document_id;
      customerId: number = cdCarePlan.customer_id;
      date: string = cdCarePlan.date;
      discussedDate: string = cdCarePlan.discussed_date;
      el: LightEmployee = cdCarePlan.el ? LightEmployeeFactory.fromObject(cdCarePlan.el) : null;
      elEmployeeId: number = cdCarePlan.el_employee_id;
      elFinished: string = cdCarePlan.el_finished;
      id: number = cdCarePlan.id;
      isPrinted: boolean = cdCarePlan.is_printed;
      mentor: LightEmployee = cdCarePlan.mentor ? LightEmployeeFactory.fromObject(cdCarePlan.mentor) : null;
      mentorEmployeeId: number = cdCarePlan.mentor_employee_id;
      mentorFinished: string = cdCarePlan.mentor_finished;
      mentorLocked: string = cdCarePlan.mentor_locked;
      modified: string = cdCarePlan.modified;
      parentId: number = cdCarePlan.parent_id;
      finished: string = cdCarePlan.finished;
      primaryNurse: LightEmployee =
        cdCarePlan.primary_nurse ? LightEmployeeFactory.fromObject(cdCarePlan.primary_nurse) : null;
      primaryNurseEmployeeId: number = cdCarePlan.primary_nurse_employee_id;
      primaryNurseFinished: string = cdCarePlan.primary_nurse_finished;
      comment: string = cdCarePlan.comment;
      isLatestFinished: boolean = cdCarePlan.is_latest_finished;
      user: LightUser = cdCarePlan.user ? LightUserFactory.fromObject(cdCarePlan.user) : null;
      userId: number = cdCarePlan.user_id;
      cdRai: CdRai = cdCarePlan.c_rai ? CdRaiFactory.fromObject(cdCarePlan.c_rai) : null;
      isLatestCdCarePlanPnFinishedButNotFinished: boolean = cdCarePlan.is_latest_c_care_plan_pn_finished_but_not_finished;
      cdFrequencies: CdFrequency[] =
        cdCarePlan.c_frequencies ? CdFrequencyFactory.fromArray(cdCarePlan.c_frequencies) : [];
      cdPrescriptions: CdPrescription[] =
        cdCarePlan.prescriptions ? CdPrescriptionFactory.fromArray(cdCarePlan.prescriptions) : [];
      cdCarePlanStatus: CdCarePlanStatus = null;
      hasNotConfirmedCdMessagesCdClarification: boolean =
        cdCarePlan.has_not_confirmed_c_messages_c_clarification ?? false;
      hasNotConfirmedCdMessagesCdRai: boolean = cdCarePlan.has_not_confirmed_c_messages_c_rai ?? false;
      hasOpenCdMessagesCdClarification: boolean = cdCarePlan.has_open_c_messages_c_clarification ?? false;
      hasOpenCdMessagesCdRai: boolean = cdCarePlan.has_open_c_messages_c_rai ?? false;
      cdPsaItems: CdPsaItem[] = cdCarePlan.psa_items ? CdPsaItemFactory.fromArray(cdCarePlan.psa_items) : [];
      cdAddedAims: CdAddedAim[] = cdCarePlan.aims ? CdAddedAimFactory.fromArray(cdCarePlan.aims) : [];
      cdAddedMeasures: CdAddedMeasure[] = cdCarePlan.measures ? CdAddedMeasureFactory.fromArray(cdCarePlan.measures) : [];
      customerPrimaryNurse: LightEmployee =
        cdCarePlan.customer?.primary_nurse ? LightEmployeeFactory.fromObject(cdCarePlan.customer.primary_nurse) : null;
    };

    _cdCarePlan.cdCarePlanStatus = this.getCdCarePlanStatus(_cdCarePlan);

    return _cdCarePlan;
  }

  /**
   *
   * @param cdCarePlans
   */
  public static fromArray(cdCarePlans: any[]): CdCarePlan[] {
    return cdCarePlans.map(_cdCarePlan => CdCarePlanFactory.fromObject(_cdCarePlan));
  }

  /**
   *
   * @param cdCarePlan
   */
  public static toRemote(cdCarePlan: CdCarePlan): any {

  }

  private static getCdCarePlanStatus(cdCarePlan: CdCarePlan): CdCarePlanStatus {
    if(!cdCarePlan.primaryNurseFinished) {
      return CdCarePlanStatus.Open;
    }
    else if(!cdCarePlan.mentorFinished) {
      return CdCarePlanStatus.WaitingForMentor;
    }
    else if(!cdCarePlan.elFinished) {
      return CdCarePlanStatus.WaitingForEl;
    }
    else {
      return CdCarePlanStatus.Finished;
    }
  }

}
